<div class="data-confirmation-step">
  <p class="main-question">
    <strong>Confirma tus datos</strong>
  </p>
  <p class="subtext">
    Revisa la información de tu documento y completa los datos faltantes.
  </p>

  <form [formGroup]="dataForm" (ngSubmit)="onSubmit()" class="form-wrapper">
    <!-- Campo oculto: país del documento -->
    <input type="hidden" formControlName="documentoPais" />

    <!-- ==================== DATOS DEL DOCUMENTO (READONLY) ==================== -->
    <div class="section-divider">
      <span>Datos del documento</span>
    </div>

    <!-- Nombres (readonly) -->
    <div class="readonly-field">
      <input
        formControlName="nombres"
        type="text"
        placeholder="Nombres"
        readonly
      />
      <span class="readonly-badge">Del documento</span>
    </div>

    <!-- Apellidos (readonly) -->
    <div class="readonly-field">
      <input
        formControlName="apellidos"
        type="text"
        placeholder="Apellidos"
        readonly
      />
      <span class="readonly-badge">Del documento</span>
    </div>

    <!-- Tipo de documento y Número de serie en fila -->
    <div class="row-two">
      <div class="readonly-field">
        <input
          formControlName="tipoDocumento"
          type="text"
          placeholder="Tipo de documento"
          readonly
        />
      </div>
      <div class="readonly-field">
        <input
          formControlName="numeroSerie"
          type="text"
          placeholder="Número de serie"
          readonly
        />
      </div>
    </div>

    <!-- ==================== DATOS EDITABLES ==================== -->
    <div class="section-divider">
      <span>Datos personales</span>
    </div>

    <!-- Número de documento oculto (ya se muestra en numeroSerie arriba) -->
    <input type="hidden" formControlName="numeroDocumento" />

    <!-- Fecha de nacimiento y Género en fila -->
    <div class="row-two">
      <div class="field-group">
        <label class="field-label">Fecha de nacimiento</label>
        <input
          formControlName="fechaNacimiento"
          type="date"
          [max]="fechaNacimientoMaxima"
        />
      </div>
      <select formControlName="sexo">
        <option value="" disabled selected>Género</option>
        <option *ngFor="let option of genderOptions" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>

    <!-- Nacionalidad con bandera -->
    <div class="select-with-flag">
      <img
        *ngIf="dataForm.get('nacionalidad')?.value"
        [src]="'assets/flags/' + getFlagForCountry(dataForm.get('nacionalidad')?.value)"
        alt="Bandera"
        class="flag-preview"
      />
      <select formControlName="nacionalidad" [class.has-value]="dataForm.get('nacionalidad')?.value">
        <option value="" disabled selected>Nacionalidad</option>
        <option *ngFor="let country of countries" [value]="country.name">
          {{ country.name }}
        </option>
      </select>
    </div>

    <!-- Fecha de vencimiento -->
    <div class="field-group">
      <label class="field-label">Fecha de vencimiento del documento</label>
      <input
        formControlName="fechaVencimiento"
        type="date"
      />
    </div>

    <!-- ==================== DATOS DE RESIDENCIA ==================== -->
    <div class="section-divider">
      <span>Residencia y actividad</span>
    </div>

    <!-- País de residencia (siempre lo declara el usuario) -->
    <div class="select-with-flag">
      <img
        *ngIf="dataForm.get('paisResidencia')?.value"
        [src]="'assets/flags/' + getFlagForCountry(dataForm.get('paisResidencia')?.value)"
        alt="Bandera"
        class="flag-preview"
      />
      <select formControlName="paisResidencia" [class.has-value]="dataForm.get('paisResidencia')?.value">
        <option value="" disabled selected>País de residencia</option>
        <option *ngFor="let country of countries" [value]="country.name">
          {{ country.name }}
        </option>
      </select>
    </div>

    <!-- Ciudad y Dirección -->
    <input
      formControlName="ciudadResidencia"
      type="text"
      placeholder="Ciudad de residencia"
    />

    <input
      formControlName="direccion"
      type="text"
      placeholder="Dirección"
    />

    <!-- Profesión -->
    <select formControlName="profesion">
      <option value="" disabled selected>Profesión u ocupación</option>
      <option *ngFor="let prof of professions" [value]="prof">
        {{ prof }}
      </option>
    </select>

    <!-- Otra profesión (si seleccionó "Otro") -->
    <input
      *ngIf="showOtherProfession"
      formControlName="otraProfesion"
      type="text"
      placeholder="Especifica tu profesión"
    />

    <!-- Volumen transaccional mensual -->
    <select formControlName="volumenMensual">
      <option value="" disabled selected>Volumen de transacciones mensual</option>
      <option *ngFor="let option of volumeOptions" [value]="option.value">
        {{ option.label }}
      </option>
    </select>

    <!-- Botones -->
    <button
      type="submit"
      [disabled]="!isFormValid || loading"
    >
      {{ loading ? 'Guardando...' : 'Continuar' }}
    </button>
    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      [disabled]="loading"
    >
      Volver
    </button>
  </form>
</div>
